export const Dashbourd = () => {
    return (
        <div>داشبورد</div>
    );
}